/** What the page reaches into the open popover tab for: paging it from the page keys. */
export type DispatchPanelHandle = {
  /** Scrolls the tab a page down (`1`) or up (`-1`); stops at either end, and never fetches. */
  scrollPage: (direction: 1 | -1) => void;
};

/** About one line a page scroll keeps in view from the page before, so the eye finds its place. */
export const PAGE_OVERLAP_PX = 24;

/**
 * Scrolls `scroller` a page in `direction`; a null scroller is a no-op.
 *
 * Passes no `behavior`, so the scroll follows the element's CSS `scroll-behavior`. Nothing sets that to `smooth` on
 * the popover's tabs, so the scroll is instant: a held key never stacks animations, and reduced motion needs no
 * special case. The browser stops the scroll at either end of the element and never chains it to the page.
 *
 * @param scroller - The element whose own scroll position moves, or null while nothing scrollable is mounted.
 * @param direction - `1` for a page down, `-1` for a page up.
 */
export function scrollByPage(scroller: HTMLElement | null, direction: 1 | -1): void {
  if (!scroller) return;
  scroller.scrollBy({ top: direction * Math.max(1, scroller.clientHeight - PAGE_OVERLAP_PX) });
}
